import { render, staticRenderFns } from "./EditcolorpagePage.vue?vue&type=template&id=4eb70ed8"
import script from "./EditcolorpagePage.vue?vue&type=script&lang=js"
export * from "./EditcolorpagePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports